import script from "./AssetPropertyAddForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./AssetPropertyAddForm.vue?vue&type=script&setup=true&lang=ts"

import "./AssetPropertyAddForm.vue?vue&type=style&index=0&id=ee097f10&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ee097f10"]])

export default __exports__